/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_External_BookingsInputs */

const en_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External Bookings`)
};

const de_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe Buchungen`)
};

const es_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas externas`)
};

const fr_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservations externes`)
};

const nl_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Externe reserveringen`)
};

const it_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenotazioni esterne`)
};

const pt_br2_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservas externas`)
};

const pl_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacje zewnętrzne`)
};

const hu_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Külső foglalások`)
};

const ro_admin_dashboard_external_bookings = /** @type {(inputs: Admin_Dashboard_External_BookingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervari Externe`)
};

/**
* | output |
* | --- |
* | "External Bookings" |
*
* @param {Admin_Dashboard_External_BookingsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_external_bookings = /** @type {((inputs?: Admin_Dashboard_External_BookingsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_External_BookingsInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_external_bookings(inputs)
	if (locale === "de") return de_admin_dashboard_external_bookings(inputs)
	if (locale === "es") return es_admin_dashboard_external_bookings(inputs)
	if (locale === "fr") return fr_admin_dashboard_external_bookings(inputs)
	if (locale === "nl") return nl_admin_dashboard_external_bookings(inputs)
	if (locale === "it") return it_admin_dashboard_external_bookings(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_external_bookings(inputs)
	if (locale === "pl") return pl_admin_dashboard_external_bookings(inputs)
	if (locale === "hu") return hu_admin_dashboard_external_bookings(inputs)
	return ro_admin_dashboard_external_bookings(inputs)
});
export { admin_dashboard_external_bookings as "admin.dashboard.external_bookings" }